import Reveal from "./Reveal";

// Available logos
const LOGOS = {
  Solucious:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/1zhcn2kj_cq5dam.web.1280.1280-1e9c8c93-9966b796.png",
  "DSM Keukens":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/4g2s9s2r_unnamed-bdfb6ee8-8e5ada51.png",
  "Euro Shop":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/7dvv5n23_images-eba55462.png",
  "De Watergroep":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/15xdvm9h_De-Watergroep.png.png",
  DFDS:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/woky301m_DFDS_Logo_Positiv_2016_RGB.png",
  Culligan:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/lvpiryec_Culligan_Logo_Blue.png",
  Dumoulin:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/j23yeuiy_wasserij_dumoulin_logo-d5d5045c.jpeg",
  Stadsbader:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/wq5k4yqu_L_Stadsbader_Q-1.webp",
  "AZ Delta":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/zl6fxeec_lgo_azDelta.png",
  "Port of Antwerp-Bruges":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/5rdm2txs_272628_clkpoablogo_761517.png",
  Verhelst:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/v46bcj7f_Verhelst-logo.png.png",
  Brustor:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/a8pdc1yq_5e9ec4a88b729-brustor-tour-player-9735a7ed.png",
  Delaware:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/pb0a8hye_Delaware-logo.svg.png",
  Bosschaert:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/7ue6e1f3_images-2.png",
  "Bouwmaterialen Modde":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/z5j4o9ku_Modde%2Blogo.png.webp",
  "Decupere & Partners":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/asnyxhwf_Decupere%20en%20partners.png",
  "Horeca Foods (Oresto Partner)":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/v4fvjelc_horecafoods-logo-2x-457b10f6.png",
  Decospan:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/syc9ptrs_DECOSPAN%2BBELGIE%2Brgb%2B300%2Bdpi.jpg",
  "Pascal Koel- & Diepvriestransport":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/ior5o3cj_8d08172cfd00d1d4825fe653026c01d3.png",
  Cargill:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/hdvbhknq_Cargill_Logo.jpg",
  "Bossuyt Grootkeukens":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/yvrk12k0_Bossuyt-keukens-ervaringen.png",
  "NV Bouvry":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/fna8vwaf_Bouvry-NV.jpg",
  "Imagopack Group":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/frkl7zjl_fb-og.png",
  "Groep Huyzentruyt":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/ba5wr60d_1.svg",
  Remotec:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/j42ejm4w_images%20%282%29.png",
  Ghistelinck:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/2lkt2auc_images%20%283%29.png",
  "Claessens Groothandel":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/xq7rdmrb_images%20%284%29.png",
  "Derma Trucks":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/qoft9qk3_images.png",
  "EEG Group":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/trwuy65o_logo%20%281%29.png",
  "My Pool":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/re80dt0u_logo_2025-10-15-144513_kmot.png",
  Arvesta:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/3hxnnd25_logo_arvesta.png",
  Galloo:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/h59ed273_logo-galloo.png",
  "Mahieu Construct":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/wqjp4iik_logo.png",
  "Flandrien Kaas":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/ev9x1pio_og-image.jpg",
  "Wijnen De Clerck":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/0269d3g0_wijnen-de-clerck.png",
  Vandewiele:
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/1h8r8sc2_vandewiele_poster.jpg",
  "Crombé Wines":
    "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/x5peeegk_share-image.webp",
};

const CLIENTS = [
  "Solucious",
  "DSM Keukens",
  "Euro Shop",
  "De Watergroep",
  "DFDS",
  "Culligan",
  "Dumoulin",
  "Stadsbader",
  "AZ Delta",
  "Port of Antwerp-Bruges",
  "Verhelst",
  "Brustor",
  "Delaware",
  "Bosschaert",
  "Bouwmaterialen Modde",
  "Bossuyt Grootkeukens",
  "Decospan",
  "Galloo",
  "Arvesta",
  "Derma Trucks",
  "Horeca Foods (Oresto Partner)",
  "Decupere & Partners",
  "Remotec",
  "Pascal Koel- & Diepvriestransport",
  "Imagopack Group",
  "Wijnen De Clerck",
  "Vandewiele",
  "Crombé Wines",
  "Ghistelinck",
  "Cargill",
  "Claessens Groothandel",
  "NV Bouvry",
  "Mahieu Construct",
  "My Pool",
  "EEG Group",
];

// Get a consistent initial/monogram from a name
function getMonogram(name) {
  const cleaned = name
    .replace(/[—\-()]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const words = cleaned.split(" ").filter((w) => w.length > 1);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return cleaned.slice(0, 2).toUpperCase();
}

export default function References() {
  return (
    <section
      id="referenties"
      data-testid="references-section"
      className="relative bg-white py-24 md:py-36 border-y border-cgborder"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-20">
            <div className="max-w-xl">
              <p className="eyebrow mb-5" data-testid="references-eyebrow">Referenties</p>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight text-cgdark">
                Vertrouwd door <br />
                <span className="text-cgprimary italic font-light">topbedrijven</span> in België.
              </h2>
            </div>
            <div className="flex items-end gap-8">
              <div>
                <div className="font-heading text-5xl md:text-6xl font-bold text-cgprimary leading-none">
                  278+
                </div>
                <div className="text-cgmuted text-xs uppercase tracking-[0.2em] mt-2">
                  Vaste klanten p/maand
                </div>
              </div>
              <p className="text-cgmuted max-w-xs text-sm leading-relaxed hidden md:block">
                Een greep uit de bedrijven die ons elke maand vertrouwen.
              </p>
            </div>
          </div>
        </Reveal>

        <div
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-px bg-cgborder"
          data-testid="references-grid"
        >
          {CLIENTS.map((name, i) => {
            const logo = LOGOS[name];
            return (
              <div
                key={name}
                data-testid={`client-card-${i}`}
                className="group bg-white aspect-square flex flex-col items-center justify-between p-5 md:p-6 hover:bg-cgsurface transition-colors duration-500 relative"
                title={name}
              >
                <div className="absolute top-3 right-3 text-cgborder text-[10px] font-mono">
                  {String(i + 1).padStart(2, "0")}
                </div>

                <div className="flex-1 w-full flex items-center justify-center min-h-0">
                  {logo ? (
                    <img
                      src={logo}
                      alt={name}
                      loading="lazy"
                      className="max-h-16 md:max-h-20 w-auto object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  ) : (
                    <div className="font-heading text-3xl md:text-4xl font-bold text-cgdark/15 group-hover:text-cgprimary tracking-tighter transition-colors duration-500 leading-none">
                      {getMonogram(name)}
                    </div>
                  )}
                </div>

                <div className="w-full pt-3 mt-3 border-t border-cgborder/70 group-hover:border-cgprimary/40 transition-colors duration-500">
                  <p className="text-[11px] md:text-[12px] font-semibold tracking-wide text-cgdark text-center leading-tight line-clamp-2">
                    {name}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <Reveal className="mt-12 md:mt-16 flex items-center justify-center">
          <p className="text-cgmuted text-sm text-center max-w-xl">
            En vele anderen vertrouwen ons hun wagenpark toe.{" "}
            <a
              href="#contact"
              className="text-cgdark font-semibold link-underline"
              data-testid="references-cta"
            >
              Word ook klant →
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
